const ENTITY_TYPES = {
    lootbox: 'lootbox',
};

export { ENTITY_TYPES };
//# sourceMappingURL=entityType.js.map
